import { z } from 'zod'

export const schema = z.object({
  posts: z.array(
    z.object({
      title: z.string(),
      url: z.string(),
      media: z.object({
        img: z.string(),
        img2x: z.string(),
      }),
      category: z.object({
        name: z.string(),
      }),
      content: z.string(),
      readingTime: z.string().optional().nullable(),
      authorName: z.string(),
      authorUrl: z.string(),
      publishDate: z.string(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>
